import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
export const popoverBodyStyles = ({ theme }) => css `
	padding: 0 ${pxToRem(theme.spacing['500'])};
`;
export const PopoverBodyContainer = styled.div `
	${popoverBodyStyles};
`;
//# sourceMappingURL=popover-body.styled.js.map